/* eslint-disable */
import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { applyMiddleware, createStore } from 'redux';
import { autoRehydrate, persistStore, storages } from 'redux-persist';
import thunk from 'redux-thunk';
import { fetchAppData } from './actions/applicationData';
import { getMember, logout, updateUser } from './actions/user';
import StripeAPIProvider from './components/StripeAPIProvider';

import { Theme } from './config/theme';
import reducer from './reducers';
import promise from './store/promise';

import ApplicationHelper from './views/ApplicationHelper';
import Blog from './views/Blog';
import BlogPost from './views/BlogPost';
import Contact from './views/Contact';
import DashboardContainer from './views/DashboardContainer';
import DogProfile from './views/DogProfile';
import EditPooch from './views/EditPooch';
import EditProfile from './views/EditProfile';
import ErrorView from './views/ErrorView';
import FAQs from './views/FAQs';
import Favourites from './views/Favourites';
import Find from './views/Find';
import Forgot from './views/Forgot';
import Home from './views/Home';
import JoinComplete from './views/JoinComplete';
import JoinContainer from './views/JoinContainer';
import JoinDetails from './views/JoinDetails';
import JoinPayment from './views/JoinPayment';
import JoinPooch from './views/JoinPooch';
import JoinProfile from './views/JoinProfile';
import JoinSubscription from './views/JoinSubscription';
import JoinVerify from './views/JoinVerify';
import LoadingView from './views/LoadingView';
import Matches from './views/Matches';
import MemberProfile from './views/MemberProfile';
import MessengerConversation from './views/MessengerConversation';
import MessengerInbox from './views/MessengerInbox';
import Privacy from './views/Privacy';
import Profiles from './views/Profiles';
import ServerErrorView from './views/ServerErrorView';
import SettingsAccount from './views/SettingsAccount';
import SettingsContainer from './views/SettingsContainer';
import SettingsDetails from './views/SettingsDetails';
import SettingsHelp from './views/SettingsHelp';
import SettingsMembership from './views/SettingsMembership';
import SettingsResources from './views/SettingsResources';
import ShareHistory from './views/ShareHistory';
import Story from './views/Story';
import Terms from './views/Terms';
import UnauthenticatedContainer from './views/UnauthenticatedContainer';
import Verify from './views/Verify';

// Initialize Google Analytics only if not pre-rendering
if (navigator.userAgent !== 'ReactSnap') {
  ReactGA.initialize('UA-48870839-48');
}

const appStore = applyMiddleware(thunk, promise)(createStore);
const store = autoRehydrate()(appStore)(reducer);

export default class Application extends Component {
  constructor() {
    super();
    this.mobBreak = this.mobBreak.bind(this);
    this.state = {
      rehydrated: false,
      isMobile: false,
    };
  }

  componentWillMount() {
    persistStore(
      store,
      { blacklist: ['routing', 'appstate', 'search'], storage: storages.localForage },
      () => {
        this.setState({
          rehydrated: true,
        });

        // Skip authentication check during react-snap pre-rendering
        if (navigator.userAgent === 'ReactSnap') {
          return;
        }

        // Check existing user (via redux-persist) and validate authentication
        const user = store.getState().user;
        if (user && user.id && user.isAuthenticated) {
          store.dispatch(getMember(user.id, user.access_token)).then(
            response => {
              if (!response) {
                store.dispatch(logout());
              } else {
                store.dispatch(updateUser(response));
              }
            },
            err => {
              console.log(err);
              store.dispatch(logout());
            },
          );
        }
      },
    );
    this.mobBreak();
  }

  componentDidMount() {
    // Skip API calls during react-snap pre-rendering
    if (navigator.userAgent === 'ReactSnap') {
      return;
    }

    // Fetch app config
    store.dispatch(fetchAppData());
  }

  mobBreak() {
    if (window.innerWidth > Theme.responsive_mobile_width && this.state.isMobile) {
      Theme.isMobile = false;
      this.setState({
        isMobile: false,
      });
    } else if (window.innerWidth <= Theme.responsive_mobile_width && !this.state.isMobile) {
      Theme.isMobile = true;
      this.setState({
        isMobile: true,
      });
    }
  }

  render() {
    if (!this.state.rehydrated) {
      return (
        <LoadingView /> // eslint-disable-line
      );
    }

    window.removeEventListener('resize', this.mobBreak);
    window.addEventListener('resize', this.mobBreak);

    return (
      <Provider store={store}>
        <StripeAPIProvider>
          <BrowserRouter>
            <ApplicationHelper ga={ReactGA}>
              <ToastContainer />
              <Switch>
                <Route path="/" exact render={props => <Home {...props} />} />
                <Route path="/story" exact component={Story} />
                <Route path="/forgot" exact component={Forgot} />
                <Route path="/contact" exact component={Contact} />
                <Route path="/verify" exact render={props => <Verify {...props} />} />
                <Redirect from="/faqs" to="/faqs-dog-owner" />
                <Route
                  path="/faqs-dog-borrower"
                  exact
                  render={props => <FAQs {...props} type="borrower" />}
                />
                <Route
                  path="/faqs-dog-owner"
                  exact
                  render={props => <FAQs {...props} type="owner" />}
                />
                <Route path="/blog" exact component={Blog} />
                <Route path="/terms" exact render={props => <Terms {...props} />} />
                <Route path="/privacy" exact render={props => <Privacy {...props} />} />
                <Route path="/blog/:slug" exact render={props => <BlogPost {...props} />} />
                <Route
                  path="/find"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <Find {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/profiles"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <Profiles {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/shares"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <Matches {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/favourites"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <Favourites {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/inbox"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <MessengerInbox {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/inbox/:conversationId"
                  exact
                  render={props => (
                    <DashboardContainer hideFooter={true}>
                      <MessengerConversation {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/history"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <ShareHistory {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/profile/:id"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <MemberProfile {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/profile/:id/edit"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <EditProfile {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/pooch/:id"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <DogProfile {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/pooch/:id/edit"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <EditPooch {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/settings/account"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <SettingsContainer>
                        <SettingsAccount {...props} />
                      </SettingsContainer>
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/settings/help"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <SettingsContainer>
                        <SettingsHelp {...props} />
                      </SettingsContainer>
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/settings/resources"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <SettingsContainer>
                        <SettingsResources {...props} />
                      </SettingsContainer>
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/settings/membership"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <SettingsContainer>
                        <SettingsMembership {...props} />
                      </SettingsContainer>
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/settings/profiles"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <SettingsContainer>
                        <SettingsDetails {...props} />
                      </SettingsContainer>
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/join/subscription"
                  exact
                  render={props => (
                    <UnauthenticatedContainer>
                      <JoinContainer step={1}>
                        <JoinSubscription {...props} />
                      </JoinContainer>
                    </UnauthenticatedContainer>
                  )}
                />
                <Route
                  path="/join/details"
                  exact
                  render={props => (
                    <UnauthenticatedContainer>
                      <JoinContainer step={2}>
                        <JoinDetails {...props} />
                      </JoinContainer>
                    </UnauthenticatedContainer>
                  )}
                />
                <Route
                  path="/join/payment"
                  exact
                  render={props => (
                    <UnauthenticatedContainer>
                      <JoinContainer step={3}>
                        <JoinPayment {...props} ga={ReactGA} />
                      </JoinContainer>
                    </UnauthenticatedContainer>
                  )}
                />
                <Route
                  path="/join/verify"
                  exact
                  render={props => (
                    <UnauthenticatedContainer>
                      <JoinVerify {...props} ga={ReactGA} />
                    </UnauthenticatedContainer>
                  )}
                />
                <Route
                  path="/join/profile"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <JoinProfile {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/join/pooch"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <JoinPooch {...props} />
                    </DashboardContainer>
                  )}
                />
                <Route
                  path="/join/complete"
                  exact
                  render={props => (
                    <DashboardContainer>
                      <JoinComplete {...props} />
                    </DashboardContainer>
                  )}
                />
                <Redirect from="/join" to="/join/subscription" />
                <Redirect from="/settings" to="/settings/profiles" />
                <Route path="/500" component={ServerErrorView} />
                <Route component={ErrorView} />
              </Switch>
            </ApplicationHelper>
          </BrowserRouter>
        </StripeAPIProvider>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Application.js